
export const DotsLoader = () => {
    return <div className="flex gap-2">
        <div className="firstdot-flashing"></div>
        <div className="seconddot-flashing"></div>
        <div className="thirddot-flashing"></div>
    </div>;
};
